module.exports = __webpack_public_path__ + "static/media/star.423a4b86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/star.svg
// module id = 1744
// module chunks = 0